import getRulesets from "qandp/promises/get-rulesets";
import getVocab from "qandp/promises/get-vocab";

export default ({ policiesApi, vocabPath, ixvocabAuth, ixvocabUrl }) =>
  Promise.all([
    getRulesets({ serviceUrl: policiesApi }),
    getVocab({ vocabPath, serviceAuth: ixvocabAuth, serviceUrl: ixvocabUrl })
  ]);
